import { Container, Row, Col } from 'react-bootstrap';
import FilterMenu from './filterMenu';
import SearchBox from './searchBox';
import { SearchFilterProps } from './types';

const SearchFilter = (props: SearchFilterProps) => {
    const {
        containerClassName = '', // default props
        className = '', // default props
        initialFilters,
        setInitialFilters,
    } = props;
    return (
        <Container className={containerClassName}>
            <Row className={className}>
                <Col>
                    <SearchBox className='d-none' />
                </Col>
                <Col className='text-end'>
                    <FilterMenu
                        initialFilters={initialFilters}
                        setInitialFilters={setInitialFilters}
                    />
                </Col>
            </Row>
        </Container>
    );
};

export default SearchFilter;
